// Module
var code = "<div id=\"googlePayButtonContainer\" style=\"width:100%;height:45px\"></div> ";
// Exports
module.exports = code;